var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaLegendA4De(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a4",
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 841.89 595.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h841.89v595.276H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(-1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M73.058 551h547.88c.91 0 1.646.816 1.646 1.823v22.881c0 1.007-.737 1.823-1.646 1.823H73.058Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text20852",
    x: 76.944,
    y: 558.357,
    style: {
      fontSize: 5,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan20850",
    x: 76.944,
    y: 558.357,
    style: {
      strokeWidth: 0.75
    }
  }, "Auf gewissen Autobuslinien ist ein Zuschlag und/oder eine Platzreservierung erforderlich. Bitte beachten Sie zudem, dass vom 21. M\xE4rz bis zum 31. Oktober f\xFCr Velos in InterCity (IC)-Z\xFCgen eine Veloplatzreservation obligatorisch ist."), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan20854",
    x: 76.944,
    y: 563.357,
    style: {
      strokeWidth: 0.75
    }
  }, "Bitte beachten Sie die Hinweise f\xFCr die gew\xFCnschte Verbindung im (Online-)Fahrplan. Aus Platzgr\xFCnden sind, je nach Zoomstufe, nicht alle Linien angegeben. Alle Angaben ohne Gew\xE4hr. \xC4nderungen vorbehalten. Es gilt der Anwendungsbereich.")), /*#__PURE__*/React.createElement("text", {
    id: "text493",
    x: 76.722,
    y: 572.645,
    style: {
      fontSize: 5,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan411",
    x: 76.722,
    y: 572.645,
    style: {
      letterSpacing: ".00684em"
    }
  }, "Q"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan413",
    x: 80.555,
    y: 572.645,
    style: {
      letterSpacing: "-.0002em"
    }
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan415",
    x: 83.335,
    y: 572.645,
    style: {
      letterSpacing: ".00254em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan417",
    x: 86.034,
    y: 572.645,
    style: {
      letterSpacing: "-.0002em"
    }
  }, "ll"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan419",
    x: 88.255,
    y: 572.645,
    style: {
      letterSpacing: ".01992em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan421",
    x: 91.041,
    y: 572.645,
    style: {
      letterSpacing: ".0002em"
    }
  }, ": OpenS"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan423",
    x: 109.289,
    y: 572.645,
    style: {
      letterSpacing: "-.0082em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan425",
    x: 110.822,
    y: 572.645,
    style: {
      letterSpacing: "-.01426em"
    }
  }, "r"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan427",
    x: 112.416,
    y: 572.645
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan429",
    x: 115.101,
    y: 572.645,
    style: {
      letterSpacing: "-.00781em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan431",
    x: 117.748,
    y: 572.645,
    style: {
      letterSpacing: "-.0002em"
    }
  }, "tMap con"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan433",
    x: 139.048,
    y: 572.645,
    style: {
      letterSpacing: "-.0082em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan435",
    x: 140.582,
    y: 572.645,
    style: {
      letterSpacing: ".00215em"
    }
  }, "r"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan437",
    x: 142.257,
    y: 572.645
  }, "ibu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan439",
    x: 149.113,
    y: 572.645,
    style: {
      letterSpacing: "-.02246em"
    }
  }, "t"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan441",
    x: 150.575,
    y: 572.645
  }, "o")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan443",
    x: 153.446,
    y: 572.645,
    style: {
      letterSpacing: ".00586em"
    }
  }, "r"), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    id: "tspan445",
    x: 155.14,
    y: 572.645
  }, "s  \xA9 SBB/CFF")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan447",
    x: 186.916,
    y: 572.645,
    style: {
      letterSpacing: ".04629em"
    }
  }, "/"), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan449",
    x: 188.812,
    y: 572.645
  }, "F")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan451",
    x: 191.683,
    y: 572.645,
    style: {
      letterSpacing: "-.01758em"
    }
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan453",
    x: 194.466,
    y: 572.645,
    style: {
      letterSpacing: ".0002em"
    }
  }, "S ww"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan455",
    x: 206.673,
    y: 572.645,
    style: {
      letterSpacing: "-.05234em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan457",
    x: 210.201,
    y: 572.645,
    style: {
      letterSpacing: ".0002em"
    }
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan459",
    x: 211.59,
    y: 572.645,
    style: {
      letterSpacing: "-.0082em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan461",
    x: 213.124,
    y: 572.645,
    style: {
      letterSpacing: "-.00352em"
    }
  }, "r"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan463",
    x: 214.771,
    y: 572.645
  }, "a\uFB01m")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan465",
    x: 224.312,
    y: 572.645,
    style: {
      letterSpacing: "-.00391em"
    }
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan467",
    x: 226.978,
    y: 572.645,
    style: {
      letterSpacing: "-.00078em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan469",
    x: 229.845,
    y: 572.645,
    style: {
      letterSpacing: "-.00781em"
    }
  }, "e"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan471",
    x: 232.492,
    y: 572.645
  }, ".")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan473",
    x: 233.88,
    y: 572.645,
    style: {
      letterSpacing: "-.00352em"
    }
  }, "c"), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan475",
    x: 236.548,
    y: 572.645
  }, "h ww")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan477",
    x: 248.296,
    y: 572.645,
    style: {
      letterSpacing: "-.05215em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan479",
    x: 251.825,
    y: 572.645,
    style: {
      letterSpacing: ".0002em"
    }
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan481",
    x: 253.214,
    y: 572.645,
    style: {
      letterSpacing: "-.00117em"
    }
  }, "g"), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan483",
    x: 256.08,
    y: 572.645
  }, "eop")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan485",
    x: 264.601,
    y: 572.645,
    style: {
      letterSpacing: "-.00254em"
    }
  }, "s"), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan487",
    x: 267.088,
    y: 572.645
  }, ".")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan489",
    x: 268.478,
    y: 572.645,
    style: {
      letterSpacing: "-.00352em"
    }
  }, "c"), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan491",
    x: 271.146,
    y: 572.645
  }, "h")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M17.008 527.244h51.024v51.024H17.008z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23867",
    d: "M18.466 528.702h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm2.917 0h1.457v1.458H35.96zm5.83 0h1.459v1.458H41.79zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm5.831 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm8.747 0h1.457v1.457H35.96zm10.204 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H49.08zm7.289 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457Zm1.457 0H62.2v1.457h-1.458zm1.458 0h1.458v1.457H62.2zm2.916 0h1.458v1.457h-1.458zm-46.65 1.457h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm2.916 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm10.205 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm2.916 0h1.458v1.458h-1.458Zm-46.65 1.458h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458H35.96zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm5.83 0h1.459v1.458H49.08zm1.459 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-33.53 1.458h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H41.79zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H49.08zm-30.614 1.457h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H28.67zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H43.25zm7.289 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H62.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H28.67zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H43.25zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-43.734 1.458h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458H28.67zm7.29 0h1.457v1.458H35.96zm5.83 0h1.459v1.458H41.79zm7.29 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H62.2zm-43.734 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458H43.25zm8.747 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm-40.818 1.458h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457H28.67zm1.458 0h1.458v1.457h-1.458zm11.663 0h1.458v1.457H41.79zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm7.29 0h1.457v1.457h-1.458zm1.457 0h1.458v1.457h-1.458zm-45.192 1.457h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H28.67zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458H35.96zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H62.2Zm-43.734 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm-43.734 1.458h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H28.67zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H49.08zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm4.373 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-42.277 1.458h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457H28.67zm7.29 0h1.457v1.457H35.96zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457H43.25zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H49.08zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457Zm1.457 0H62.2v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zM18.466 556.4h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm13.12 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H62.2zm-43.734 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm1.459 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm1.458 0h1.457v1.458H43.25zm7.289 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458H28.67zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm7.289 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm4.373 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H28.67zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H43.25zm7.289 0h1.458v1.458h-1.458Zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H28.67zm4.374 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm-43.734 1.458h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457H28.67zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm1.458 0h1.457v1.457H35.96zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457H43.25zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458Zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457Zm1.457 0H62.2v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm-34.988 1.457h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm4.373 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm2.916 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458H35.96zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.65 1.458h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H43.25zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458Zm2.915 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457H41.79zm1.458 0h1.457v1.457H43.25zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H49.08zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457Zm1.457 0H62.2v1.457h-1.458zm1.458 0h1.458v1.457H62.2zm-43.734 1.457h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H41.79zm7.289 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0H62.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458h-1.458zm8.747 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H35.96zm5.83 0h1.459v1.458H41.79zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H49.08zm1.458 0h1.458v1.458h-1.458Zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457Zm1.457 0H62.2v1.458h-1.458zm1.458 0h1.458v1.458H62.2zm-43.734 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458H35.96zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H43.25zm7.289 0h1.458v1.458h-1.458Zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm7.29 0H62.2v1.458h-1.458zm2.915 0h1.458v1.458h-1.458z",
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M628.838 17.008h196.044v22.94H628.838z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M630.289 18.258h192.107v20.659H630.289z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M630.289 38.704h60.702V18.47h-60.702v20.234Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M666.02 27.039h6.563v-5.196h3.092v5.196h6.563l-5.28-5.196h3.918l6.745 6.744-6.745 6.745h-3.921l5.28-5.196h-6.56v5.196h-3.092v-5.196h-6.563l5.28 5.196h-3.916l-6.745-6.744 6.745-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M697.255 31.303c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.544 0-3.211-3.173-3.866-4.205-4.122-3.55-.914-4.224-1.053-4.224-2.142 0-1.19 1.149-1.606 2.143-1.606 1.487 0 2.698.435 2.796 2.142h3.015c0-3.272-2.717-4.56-5.672-4.56-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.025 2.082.555 4.203.814 4.203 2.34 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M714.21 24.264h2.916c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.862c2.559 0 5-1.229 5-4.105 0-1.765-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.925-2.956c0-2.637-1.825-3.51-4.523-3.51h-6.664v14.162Zm3.114-6.307h3.39c1.329 0 2.241.577 2.241 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M728.148 24.264h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.861c2.56 0 4.998-1.229 4.998-4.105 0-1.765-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.923-2.956c0-2.637-1.823-3.51-4.52-3.51h-6.664v14.162Zm3.115-6.307h3.39c1.33 0 2.242.577 2.242 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M756.674 26.603c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.961 3.273-6.961 7.476 0 4.086 2.577 7.359 6.96 7.359 3.472 0 5.91-2.26 6.228-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.797 0-3.85-2.38-3.85-4.74 0-2.48 1.054-4.86 3.85-4.86 1.545 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M758.71 36.005h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M770.56 36.005h3.104v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M787.241 36.005h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M799.464 36.005h3.105v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M810.562 31.303c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.888-1.944 5.888-4.544 0-3.211-3.176-3.866-4.193-4.122-3.55-.914-4.228-1.053-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.142h2.998c0-3.272-2.712-4.56-5.656-4.56-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.123 3.471 4.23 4.025 2.07.555 4.192.814 4.192 2.34 0 1.448-1.659 1.766-2.747 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path513",
    d: "M338.618 70.905H0V17.04h338.616a1.714 1.985 0 0 1 1.714 1.984v49.897c0 1.095-.769 1.984-1.713 1.984z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text735",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 12,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.157 32.43)"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan501",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan510"
  }, "General-Abo, GA Night, GA-Monatskarte, Tageskarte"))), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan503",
    x: 0,
    y: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan505"
  }, "zum Halbtax sowie f\xFCr Spartageskarte / Aktionstageskarte /"))), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan508",
    x: 0,
    y: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan511"
  }, "Spartageskarte Gemeinde zusammen mit Halbtax-Abo"))))), /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 172.589,
    height: 111.483,
    x: 9.457,
    y: 77.632,
    rx: 1.984,
    ry: 1.984,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text745",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(62.56 178.12)"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan739",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan741",
    x: 8.341,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan743",
    x: 11.476,
    y: 0
  }, "m"))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M125.04 172.298v9.44l-107.434.052v-9.494",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g765"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text751",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(17.075 114.12)"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan749",
    x: 0,
    y: 0
  }, "Bahnen"))), /*#__PURE__*/React.createElement("g", {
    id: "g763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line753",
    d: "M18.29 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line755",
    d: "M18.29 104.326v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line757",
    d: "M21.056 104.326H44.57",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line759",
    d: "M45.953 104.326v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g783"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text769",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(102.438 114.225)"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan767",
    x: 0,
    y: 0
  }, "Seilbahnen"))), /*#__PURE__*/React.createElement("g", {
    id: "g781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line771",
    d: "M103.358 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line773",
    d: "M103.358 104.326v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line775",
    d: "M106.124 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line777",
    d: "M131.021 104.326v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text797",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(145.12 146.932)"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan785",
    x: 0,
    y: 0
  }, "G\xFCl")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan787",
    x: 9.223,
    y: 0,
    style: {
      letterSpacing: "-.0127em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan789",
    x: 11.036,
    y: 0,
    style: {
      letterSpacing: "-.00146em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan791",
    x: 12.36,
    y: 0,
    style: {
      letterSpacing: "-.00293em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan793",
    x: 15.788,
    y: 0,
    style: {
      letterSpacing: "-.0249em"
    }
  }, "k"), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan795",
    x: 18.753,
    y: 0
  }, "eit"))), /*#__PURE__*/React.createElement("text", {
    id: "text815",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot"
    },
    transform: "translate(145.12 154.133)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan799",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02301em"
    }
  }, "v"), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan801",
    x: 2.862,
    y: 0
  }, "or O")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan803",
    x: 14.532,
    y: 0,
    style: {
      letterSpacing: ".03123em"
    }
  }, "r"), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan805",
    x: 16.717,
    y: 0
  }, "t")), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan807",
    x: 0,
    y: 7.2
  }, "anf")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan809",
    x: 8.335,
    y: 7.2,
    style: {
      letterSpacing: "-.00345em"
    }
  }, "ra"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan811",
    x: 13.512,
    y: 7.2,
    style: {
      letterSpacing: "-.00099em"
    }
  }, "ge"), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan813",
    x: 20.174,
    y: 7.2
  }, "n")))), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line818",
    d: "M145.893 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line820",
    d: "M148.659 137.151h23.514",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line822",
    d: "M173.556 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g854"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text840",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(145.12 114.225)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan828",
    x: 0,
    y: 0,
    style: {
      letterSpacing: ".00049em"
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan830",
    x: 3.891,
    y: 0,
    style: {
      letterSpacing: "-.00342em"
    }
  }, "c"), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan832",
    x: 7.093,
    y: 0
  }, "hi")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan834",
    x: 11.763,
    y: 0,
    style: {
      letterSpacing: ".02344em"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan836",
    x: 13.679,
    y: 0,
    style: {
      letterSpacing: "-.01904em"
    }
  }, "f"), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan838",
    x: 15.34,
    y: 0
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line842",
    d: "M145.893 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line844",
    d: "M145.893 104.326v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line846",
    d: "M148.659 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line848",
    d: "M173.556 104.326v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text868",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(59.806 114.214)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan856",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.00586em"
    }
  }, "A"), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan858",
    x: 3.853,
    y: 0
  }, "u")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan860",
    x: 7.189,
    y: 0,
    style: {
      letterSpacing: "-.02246em"
    }
  }, "t"), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan862",
    x: 8.944,
    y: 0
  }, "obu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan864",
    x: 19.283,
    y: 0,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s"), _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan866",
    x: 22.313,
    y: 0
  }, "se"))), /*#__PURE__*/React.createElement("g", {
    id: "g890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line870",
    d: "M61.07 100.564h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line872",
    d: "M60.824 104.326v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line874",
    d: "M63.59 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line876",
    d: "M88.488 104.326v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line880",
    d: "M60.824 100.564h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M60.824 104.326v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line884",
    d: "M63.59 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line886",
    d: "M88.488 104.326v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text908",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(17.075 146.933)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan894",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02832em"
    }
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan896",
    x: 3.275,
    y: 0,
    style: {
      letterSpacing: "-.01416em"
    }
  }, "r"), _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan898",
    x: 5.188,
    y: 0
  }, "eie")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan900",
    x: 14.634,
    y: 0,
    style: {
      letterSpacing: "-.02686em"
    }
  }, "F"), _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan902",
    x: 17.918,
    y: 0
  }, "ah")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan904",
    x: 24.478,
    y: 0,
    style: {
      letterSpacing: ".03125em"
    }
  }, "r"), _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan906",
    x: 26.663,
    y: 0
  }, "t")))), /*#__PURE__*/React.createElement("g", {
    id: "g923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line911",
    d: "M18.167 125.783h27.664",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line913",
    d: "M18.167 133.361h27.664",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line915",
    d: "M18.168 137.151h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line917",
    d: "M18.413 129.572h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line919",
    d: "M18.167 129.572h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1007"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text963",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(59.756 146.933)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan927",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02686em"
    }
  }, "F"), _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan929",
    x: 3.284,
    y: 0
  }, "ah")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan931",
    x: 9.844,
    y: 0,
    style: {
      letterSpacing: ".03125em"
    }
  }, "r"), _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan933",
    x: 12.029,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan935",
    x: 15.586,
    y: 0,
    style: {
      letterSpacing: "-.01172em"
    }
  }, "z"), _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan937",
    x: 18.396,
    y: 0
  }, "um")), _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan939",
    x: 0,
    y: 7.2
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan941",
    x: 3.223,
    y: 7.2,
    style: {
      letterSpacing: ".00439em"
    }
  }, "r"), _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan943",
    x: 5.247,
    y: 7.2
  }, "m\xE4")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan945",
    x: 13.588,
    y: 7.2,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s"), _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan947",
    x: 16.617,
    y: 7.2
  }, "s")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan949",
    x: 19.617,
    y: 7.2,
    style: {
      letterSpacing: "-.00146em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan951",
    x: 20.941,
    y: 7.2,
    style: {
      letterSpacing: "-.00049em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan953",
    x: 24.384,
    y: 7.2,
    style: {
      letterSpacing: "-.02051em"
    }
  }, "t"), _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan955",
    x: 26.15,
    y: 7.2
  }, "en")), _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan957",
    x: 0,
    y: 14.4
  }, "P")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan959",
    x: 3.888,
    y: 14.4,
    style: {
      letterSpacing: "-.01416em"
    }
  }, "r"), _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan961",
    x: 5.801,
    y: 14.4
  }, "eis"))), /*#__PURE__*/React.createElement("g", {
    id: "g971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line965",
    d: "M60.825 125.783v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line967",
    d: "M63.592 125.783h23.513",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line969",
    d: "M88.489 125.783v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line973",
    d: "M60.825 133.361v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line975",
    d: "M63.592 133.361h23.513",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line977",
    d: "M88.489 133.361v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line981",
    d: "M60.825 137.151v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line983",
    d: "M63.592 137.151h23.513",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line985",
    d: "M88.489 137.151v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line989",
    d: "M60.825 129.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line991",
    d: "M63.592 129.572h23.513",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line993",
    d: "M88.489 129.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line997",
    d: "M60.825 129.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line999",
    d: "M63.592 129.572h23.513",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1001",
    d: "M88.489 129.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1031",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(102.438 146.933)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1009",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02588em"
    }
  }, "K"), _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1011",
    x: 3.847,
    y: 0
  }, "eine")), _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1013",
    x: 0,
    y: 7.2
  }, "E")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1015",
    x: 3.665,
    y: 7.2,
    style: {
      letterSpacing: ".00439em"
    }
  }, "r"), _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1017",
    x: 5.689,
    y: 7.2
  }, "m\xE4")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1019",
    x: 14.03,
    y: 7.2,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s"), _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1021",
    x: 17.06,
    y: 7.2
  }, "s")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1023",
    x: 20.06,
    y: 7.2,
    style: {
      letterSpacing: "-.00146em"
    }
  }, "i"), _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1025",
    x: 21.384,
    y: 7.2
  }, "gu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1027",
    x: 28.166,
    y: 7.2,
    style: {
      letterSpacing: "-.00244em"
    }
  }, "n"), _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1029",
    x: 31.488,
    y: 7.2
  }, "g")))), /*#__PURE__*/React.createElement("path", {
    id: "line1034",
    d: "M103.358 137.151h27.664",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1042",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(41.786 88.501)"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1038",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1047",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.075 88.501)"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1072",
    x: 0,
    y: 0
  }, "Erstellt am")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaLegendA4De);
export default __webpack_public_path__ + "static/media/ga_legend_a4_de.73c2f7da1178f12effb046addc945d02.svg";
export { ForwardRef as ReactComponent };